import(/* webpackMode: "eager" */ "/home/ubuntu/download_staging/69e8533d63911b00144a45d4_1780899190380_121dad68/brickwellhousing/src/app/about/page.tsx");
